export default "__VITE_ASSET__0dd98f7f__"